
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getBookmarkPresentationsByID, getBookmarkPresentationsFilterFormsByBookmarkPresentation,
} from "@/helpers/ol/ol-layer-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {loadInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";

export class LayerInfoCharacteristicsLayerSelectComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const id = this.getAttribute('data-id');

        let innerHtml = ''
        innerHtml += `<select size="1" class="custom-select"><option>Kies laag</option>`

        window.layersActive.map((layerActive) => {
            const bookmarkPresentationActive = getBookmarkPresentationsByID(layerActive)
            if(bookmarkPresentationActive) {
                let selected = ''

                if (bookmarkPresentationActive.ID === parseInt(id)) {
                    selected = 'selected="selected"'
                }

                innerHtml += `<option value="` + bookmarkPresentationActive.ID + `" ` + selected + `>` + bookmarkPresentationActive.DisplayName + `</option>`
            }
        })
        innerHtml += `</select>`;

        template.innerHTML = innerHtml
        initWebComponent(this, template)

        this.addEventListener('change', (element) => {
            loadInfoCharacteristics(element.target.value)
        })
    }
}

